// extracted by mini-css-extract-plugin
export default {"addModalContainer":"AddAdmin_addModalContainer__9o+7Q","addElementCont":"AddAdmin_addElementCont__dZaAU","submitButton":"AddAdmin_submitButton__8ZCp8"};